import * as React from 'react'
import { useStoreState, useStoreActions } from 'easy-peasy'
import pgk from '../../../package.json'

import './Header.scss'

import Logo from '../../images/logo.svg'

const Header = () => {
  const isLoggedIn = useStoreState(state => state.user.isLoggedIn)
  const doLogout = useStoreActions(actions => actions.user.doLogout)

  return (
    <div className="site-header">
      <div className="logo">
        <img src={Logo} className="logo-image" alt="1W.VC logo" />
        <div className="brand">1W.VC</div>
        <div className="slogan">The link shortener</div>
      </div>
      <div className="header-right">
        <span className="version">v{pgk.version}</span>
        {isLoggedIn && (
          <button
            className="logout-btn"
            onClick={() => {
              doLogout({})
            }}
          >
            Log out
          </button>
        )}
      </div>
    </div>
  )
}

export default Header
